/* Estado global do Kaching Cart (Splashio, 28/10/2026).
   O app nao expoe evento de abrir/fechar; ele muda data-open/class do #kaching-cart. Um unico MutationObserver nesses
   atributos poe/tira body.kaching-cart-open (a barra fixa e os botoes flutuantes somem pelo CSS em sp-kaching-cart.css)
   e dispara "sp:kaching-cart" {open} para quem precisar (sp-sticky-atc). Nada de tempo fixo. */
(function () {
  'use strict';
  if (window.__spKachingCartState) return;
  window.__spKachingCartState = true;

  var CLS = 'kaching-cart-open';
  var aberto = null;

  function estaAberto(el) {
    return el.getAttribute('data-open') === 'true' || el.classList.contains('active');
  }

  function aplica(el) {
    var agora = estaAberto(el);
    if (agora === aberto) return;
    aberto = agora;
    document.body.classList.toggle(CLS, agora);
    window.spKachingCartOpen = agora;
    try { document.dispatchEvent(new CustomEvent('sp:kaching-cart', { detail: { open: agora } })); } catch (e) {}
  }

  function liga(el) {
    aplica(el);
    new MutationObserver(function () { aplica(el); })
      .observe(el, { attributes: true, attributeFilter: ['data-open', 'class'] });
  }

  function procura() {
    var el = document.getElementById('kaching-cart');
    if (el) { liga(el); return; }
    // o app injeta o carrinho depois do carregamento: espera ele aparecer e desliga a espera
    var espera = new MutationObserver(function () {
      var e = document.getElementById('kaching-cart');
      if (e) { espera.disconnect(); liga(e); }
    });
    espera.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) procura();
  else document.addEventListener('DOMContentLoaded', procura);
})();
